export default {
  // 导航
  path: '/credit-management',
  component: { render: h => h('router-view') },
  children: [
    {
      // 二级路由 credit-request 单笔申请
      path: '/credit-management/credit-request',
      component: {
        render: h => h('router-view'),
      },
      children: [
        {
          path: '/credit-management/credit-request/home',
          component: () =>
            import('@/views/credit-management/credit-request/home'),
        },
        {
          path: '/credit-management/credit-request/:customerId/detail',
          component: () =>
            import('@/views/credit-management/credit-request/detail'),
        },
        {
          path: '/credit-management/credit-request/query',
          component: () =>
            import('@/views/credit-management/credit-request/query'),
        },
        {
          path: '/credit-management/css-request/:customerId/detail',
          component: () =>
            import('@/views/credit-management/css-request/detail'),
        },
      ],
    },
    {
      // 二级路由 credit-batch-request
      path: '/credit-management/credit-batch-request',
      component: {
        render: h => h('router-view'),
      },
      children: [
        {
          path: '/credit-management/credit-batch-request/home',
          component: () =>
            import('@/views/credit-management/credit-batch-request/home'),
        },
        {
          name: 'batchSubmitDetail',
          path: '/credit-management/credit-batch-request/detail',
          component: () =>
            import('@/views/credit-management/credit-batch-request/detail'),
        },
        {
          name: 'batchAuditDetail',
          path: '/credit-management/credit-batch-request/audit-detail',
          component: () =>
            import(
              '@/views/credit-management/credit-batch-request/audit-detail'
            ),
        },
        // pending audit list
        {
          name: 'pendingAuditList',
          path: '/credit-management/credit-batch-request/pending-audit-list',
          component: () =>
            import(
              '@/views/credit-management/credit-batch-request/pending-list'
            ),
        },
      ],
    },
    {
      // 二级路由 credit-audit
      path: '/credit-management/credit-audit',
      component: {
        render: h => h('router-view'),
      },
      children: [
        {
          path: '/credit-management/credit-audit/single-audit',
          component: () =>
            import('@/views/credit-management/credit-audit/single-audit'),
        },
        {
          path: '/credit-management/credit-audit/batch-audit',
          component: () =>
            import('@/views/credit-management/credit-audit/batch-audit'),
        },
        {
          path: '/credit-management/css-audit/single-audit',
          component: () =>
            import('@/views/credit-management/css-audit/single-audit'),
        },
        {
          name: 'css_second_audit',
          path: '/credit-management/css-audit/css-second-audit',
          component: () =>
            import('@/views/credit-management/css-audit/second-audit'), // 二次审批
        },
        {
          name: 'css_final_audit',
          path: '/credit-management/css-audit/css-final-audit',
          component: () =>
            import('@/views/credit-management/css-audit/final-audit'), // css最后审批
        },
      ],
    },
    {
      // 二级路由 credit audit history
      path: '/credit-management/credit-audit-history',
      component: {
        render: h => h('router-view'),
      },
      children: [
        {
          path: '/credit-management/credit-audit-history/single-history',
          component: () =>
            import(
              '@/views/credit-management/credit-audit-history/single-history'
            ),
        },
        {
          path: '/credit-management/credit-audit-history/batch-history',
          component: () =>
            import(
              '@/views/credit-management/credit-audit-history/batch-history'
            ),
        },
      ],
    },
    {
      // 二级路由 All credit audit history
      path: '/credit-management/all-credit-history',
      component: {
        render: h => h('router-view'),
      },
      children: [
        {
          path: '/credit-management/all-credit-history/single-all',
          component: () =>
            import('@/views/credit-management/credit-all-history/single-all'),
        },
        {
          path: '/credit-management/all-credit-history/batch-all',
          component: () =>
            import('@/views/credit-management/credit-all-history/batch-all'),
        },
      ],
    },
  ],
}
